export default __webpack_public_path__ + "static/media/landing_pic.4338e2d6.webp";